import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <div className="hero">
      <video autoPlay muted loop playsInline className="hero-video">
        <source src="/FW-vid.mp4" type="video/mp4" />
      </video>

      <div className="hero-overlay" />

      <div className="hero-logo">
        <img src="/bnbn.png" alt="Logo" />
      </div>
    </div>
  );
}

export default Hero;